import "./conversationEntry.css";
import * as ConversationEntryUtil from "../helpers/conversationEntryUtil";

// Import children components to plug in and render.
import TextMessage from "./textMessage";
import ParticipantChange from "./participantChange";
import RichComponentMessage from "./richComponentMessage";

export default function ConversationEntry({conversationEntry, onAwacAction, onAwacRender}) {

    return (
        <>
            <div className="conversationEntryContainer">
                {/* Render an AWAC adaptive-web component when the entry is an AWAC envelope. */}
                {ConversationEntryUtil.isAwacMessage(conversationEntry) &&
                    <RichComponentMessage
                        conversationEntry={conversationEntry}
                        onAwacAction={onAwacAction}
                        onAwacRender={onAwacRender} />}
                {/* Render component for a conversation entry of type Text Message (non-AWAC). */}
                {ConversationEntryUtil.isTextMessage(conversationEntry) && <TextMessage conversationEntry={conversationEntry} />}
                {/* Render component for a conversation entry of type Participant Change. */}
                {ConversationEntryUtil.isParticipantChangeEvent(conversationEntry) && <ParticipantChange conversationEntry={conversationEntry} />}
            </div>
        </>
    );
}
